module.exports = __webpack_public_path__ + "img/40_38_052_110.0ef4bf0e.jpg";